<template>
  <Padding :padding>
    <ImageAtom
      v-if="imageAtom"
      v-bind="imageAtom"
    />
  </Padding>
</template>

<script lang="ts" setup>
import ImageAtom from '~/components/Atoms/ImageAtom/ImageAtom.vue';
import Padding from '~/components/Atoms/Padding/Padding.vue';
import type { PortableTextImage } from '~/sanity/types';
defineProps<PortableTextImage>();
</script>
<style></style>
